
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 8L20 8C20 7.73478 19.8946 7.48043 19.7071 7.29289L19 8ZM14 3L14.7071 2.29289C14.5196 2.10536 14.2652 2 14 2L14 3ZM14 8L13 8L13 9L14 9L14 8ZM19 20L20 20L19 20ZM6 22L18 22L18 20L6 20L6 22ZM4 4L4 20L6 20L6 4L4 4ZM20 20L20 8L18 8L18 20L20 20ZM14 2L6 2L6 4L14 4L14 2ZM19.7071 7.29289L14.7071 2.29289L13.2929 3.70711L18.2929 8.70711L19.7071 7.29289ZM13 3L13 8L15 8L15 3L13 3ZM14 9L19 9L19 7L14 7L14 9ZM18 22C19.1046 22 20 21.1046 20 20L18 20L18 20L18 22ZM6 20L4 20C4 21.1046 4.89543 22 6 22L6 20ZM6 4L6 2C4.89543 2 4 2.89543 4 4L6 4Z","fill":"#262D33"}}),_c('path',{attrs:{"d":"M9.17157 15.4147C8.78105 15.8052 8.78105 16.4384 9.17157 16.8289C9.5621 17.2194 10.1953 17.2194 10.5858 16.8289L9.17157 15.4147ZM14.8284 12.5862C15.219 12.1957 15.219 11.5626 14.8284 11.172C14.4379 10.7815 13.8047 10.7815 13.4142 11.172L14.8284 12.5862ZM10.5858 11.172C10.1953 10.7815 9.5621 10.7815 9.17157 11.172C8.78105 11.5626 8.78105 12.1957 9.17157 12.5862L10.5858 11.172ZM13.4142 16.8289C13.8047 17.2194 14.4379 17.2194 14.8284 16.8289C15.219 16.4384 15.219 15.8052 14.8284 15.4147L13.4142 16.8289ZM10.5858 16.8289L12.7071 14.7076L11.2929 13.2933L9.17157 15.4147L10.5858 16.8289ZM12.7071 14.7076L14.8284 12.5862L13.4142 11.172L11.2929 13.2933L12.7071 14.7076ZM12.7071 13.2933L10.5858 11.172L9.17157 12.5862L11.2929 14.7076L12.7071 13.2933ZM9.17157 12.5862L13.4142 16.8289L14.8284 15.4147L10.5858 11.172L9.17157 12.5862Z","fill":"#262D33"}})])
          )
        }
      }
    